import { render } from "./ClassDropdown.vue?vue&type=template&id=770738b0&scoped=true"
import script from "./ClassDropdown.vue?vue&type=script&lang=js"
export * from "./ClassDropdown.vue?vue&type=script&lang=js"

import "./ClassDropdown.vue?vue&type=style&index=0&id=770738b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770738b0"]])

export default __exports__